$(document).ready(function () {
  $(".column-tab a").on("click", function (e) {
    e.preventDefault();

    // Remove 'active' class from all tabs and contents
    $(".column-tab").removeClass("active");
    $(".tab-content").removeClass("active");

    // Add 'active' class to the clicked tab
    $(this).parent().addClass("active");

    // Add 'active' class to the corresponding content
    var target = $(this).attr("href");
    $(target).addClass("active");
  });
});

$(document).ready(function () {
  $('a[href^="#judgeme_product_reviews"]').on("click", function (event) {
    event.preventDefault();
    $("html, body").animate({
        scrollTop: $($.attr(this, "href")).offset().top - 100,
      },
      500
    );
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const element = document.querySelector('.have_link_url.banner');
  if (element) {
    element.addEventListener('click', function() {
      const url = this.getAttribute('have_link_url');
      if (url) {
        window.location.href = url;
      }
    });
  }
});

// Code to exit the product media lightbox start
$(document).on('click', '.pswp__item', function (e) {
  if (!$(e.target).is('.pswp__img')) {
    $('.pswp__button--close').trigger('click');
  }
});
// Code to exit the product media lightbox end 


function manageVideoPlayback() {
  document.querySelectorAll('.pswp__item').forEach(item => {
    const isActive = item.getAttribute('aria-hidden') === 'false';
    const videoElement = item.querySelector('video');
    const playButton = item.querySelector('.play-button');

    if (isActive) {
      if (videoElement) {
        // Unmute only on active slide
        videoElement.muted = false;

        if (videoElement.paused) {
          videoElement.play().catch(err => console.log('Autoplay blocked:', err));
          console.log('Video playing (unmuted) on active slide:', videoElement);
        }
      }

      if (playButton && !videoElement) {
        playButton.click();
        console.log('Play button clicked on active slide');
      }
    } else {
      if (videoElement) {
        // Mute and pause inactive videos
        videoElement.muted = true;
        if (!videoElement.paused) {
          videoElement.pause();
          console.log('Video paused (muted) on inactive slide:', videoElement);
        }
      }
    }
  });
}

// Better handling of video play on clicking .product__media
$(document).on('click', '.product__media-list .product__media', function() {
  setTimeout(() => {
    const activeItem = document.querySelector('.pswp__item[aria-hidden="false"]');
    if (activeItem) {
      const playButton = activeItem.querySelector('.play-button');
      const videoElement = activeItem.querySelector('video');

      if (videoElement) {
        // Unmute and play video directly
        videoElement.muted = false;
        if (videoElement.paused) {
          videoElement.play().catch(err => console.log('Autoplay blocked:', err));
          console.log('Directly playing video (unmuted) on active slide');
        }
      } else if (playButton) {
        playButton.click();
        console.log('Play button clicked on active slide');
      }
    }
  }, 500);
});

// Arrow button click handling
$(document).on('click', '.pswp__button--arrow', function() {
  setTimeout(manageVideoPlayback, 200);
});

// Handle click on non-active slide to manage playback
$(document).on('click', '.pswp__item[aria-hidden="true"]', function() {
  manageVideoPlayback();
});


// custom js code 

  $(document).ready(function() {
    $('body').on('click', '.custom-product-atc-btn', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var $btn = $(this);

      if ($btn.attr('aria-busy') === 'true') return;

      var $form = $btn.closest('.product-form');
      var variantId = $form.find('input[name="id"]').val();
      var quantity = parseInt($form.find('input[name="quantity"]').val()) || 1;

      if (!variantId) {
        return;
      }

      $btn.attr('aria-busy', 'true').prop('disabled', true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }]
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Failed to add to cart');
        return response.json();
      })
      .then(data => {
        return fetch('/cart.js');
      })
      .then(res => res.json())
      .then(cart => {
        var $cartCount = $('cart-count');
        $cartCount.text(cart.item_count).removeAttr('hidden');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
      })
      .catch(err => {
        alert(err.message || 'Error adding to cart');
      })
      .finally(() => {
        $btn.removeAttr('aria-busy').prop('disabled', false);
      });

    });
  });